// ============================================================================
// RUSSIAN TRANSLATIONS - BIBLE TREASURES
// ============================================================================
// Духовные сокровища из Слова

export const bibleTreasures = [
  {
    type: "perle_sagesse",
    content: "Божественная мудрость - не абстрактная теория, а конкретная жизнь, проявляющаяся в наших ежедневных выборах",
    reference: "Притчи 3:13-18",
    category: "мудрость",
    strongNumbers: {
      "мудрость": "H2451", // חָכְמָה (chokmah) = практическая мудрость
      "разум": "H8394" // תְּבוּנָה (tebunah) = различение
    },
    reflection: "Как я могу применить божественную мудрость в своих решениях сегодня?"
  },
  {
    type: "tresor_divine",
    content: "Божья любовь не зависит от наших заслуг, это вечный дар, исходящий из Его собственной природы",
    reference: "Римлянам 8:38-39",
    category: "любовь",
    strongNumbers: {
      "любовь": "G26", // ἀγάπη (agape) = безусловная любовь
      "отлучить": "G5563" // χωρίζω (chorizo) = разделить
    },
    reflection: "Ничто не может отлучить нас от любви Божией, явленной во Христе"
  },
  {
    type: "lumiere_vie",
    content: "Иисус - свет, освещающий не только наш путь, но и наше внутреннее существо",
    reference: "Иоанна 8:12",
    category: "идентичность",
    strongNumbers: {
      "свет": "G5457", // φῶς (phos) = свет
      "жизнь": "G2222" // ζωή (zoe) = изобильная жизнь
    },
    reflection: "Как я позволяю свету Христа освещать мои области тьмы?"
  },
  {
    type: "force_divine",
    content: "Наша сила исходит не из нас самих, а от Того, кто живет в нас",
    reference: "Ефесянам 3:16-17",
    category: "сила",
    strongNumbers: {
      "утвердиться": "G2901", // κραταιόω (krataioo) = укреплять
      "сила": "G1411" // δύναμις (dynamis) = божественная сила
    },
    reflection: "В моменты слабости доверяю ли я силе Божией?"
  },
  {
    type: "paix_profonde",
    content: "Божий мир не зависит от внешних обстоятельств, а от Его постоянного присутствия в наших сердцах",
    reference: "Филиппийцам 4:6-7",
    category: "безмятежность",
    strongNumbers: {
      "мир": "G1515", // εἰρήνη (eirene) = полный мир
      "соблюдет": "G5432" // φρουρέω (phroureo) = хранить как крепость
    },
    reflection: "Как я взращиваю мир Божий, превосходящий всякий ум?"
  },
  {
    type: "esperance_vivante",
    content: "Наша надежда - не неопределенное желание, а твердый якорь, основанный на верных обетованиях Бога",
    reference: "Евреям 6:19",
    category: "надежда",
    strongNumbers: {
      "надежда": "G1680", // ἐλπίς (elpis) = уверенная надежда
      "якорь": "G45" // ἄγκυρα (ankyra) = якорь души
    },
    reflection: "На каких обетованиях Бога я закрепляю свою надежду сегодня?"
  },
  {
    type: "transformation",
    content: "Духовное преображение - непрерывный процесс, в котором мы каждый день становимся более похожими на образ Христа",
    reference: "2 Коринфянам 3:18",
    category: "рост",
    strongNumbers: {
      "преображаемся": "G3339", // μεταμορφόω (metamorphoo) = полностью преображать
      "слава": "G1391" // δόξα (doxa) = божественная слава
    },
    reflection: "Какие области моей жизни нуждаются в преображении сегодня?"
  }
];

export default bibleTreasures;
